import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import ExtraLight from "./TicketExtraLight.woff2";

export const TicketExtraLightFontFaces: ExcalidrawFontFaceDescriptor[] = [
  // Thin  ExtraLight  Light  Regular  Medium  SemiBold  Bold  ExtraBold
  { uri: ExtraLight },
];
